module.exports = __webpack_public_path__ + "static/project-2a-95bb995ad1ae3f5c0e86d14ac4694e35.png";